import { isInPremiumSupportFlight } from './isInPremiumSupportFlight';
import { isFeatureEnabled } from 'owa-feature-flags';

const PREMIUM_SUPPORT_TREATMENT_FLIGHTNAME: string = 'auth-PremiumSupportTreatment';

export default async function isInPremiumSupportTreatmentFlight() {
    if (isFeatureEnabled('auth-PremiumSupportTreatment')) {
        return await isInPremiumSupportFlight(PREMIUM_SUPPORT_TREATMENT_FLIGHTNAME);
    }

    return false;
}
